import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";


import buttonConfig from "./button-config.js";
import SelectCircleMember from "./select-circle-member/select-circle-member.js";
import PlayScreenCard from "../play-screen/play-screen-card.js";

import HomeSessionsPage from "./home-sessions-page";

import ProgressMap from "./progress-map/progress-map.js"

import {getPlayerByHomeUser} from "../../../modules/player.js";


class HomePlayerDashboard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            player: false,            
            gotPLayerData: false,
            started: false,
            circleMembers: [],
            selectedCircleMember: false
        }
    }

    async componentDidMount() {

        let {token} = this.props;

        if (token) {
            let playerResponse = await getPlayerByHomeUser(token);

            if (playerResponse.data.success) {
                let player = playerResponse.data.player_data;
                let circleMembers = player.circle_members;
                this.setState({player: player, circleMembers: circleMembers});
            }
        }

       
        
    }

    start() {
        this.setState({ started: true});
    }

    printButtons() {
        let {token} = this.props;
        return buttonConfig.map((cardData) => {
            return <PlayScreenCard card_data={cardData} token={token} />
        })
    }

    circleMemberSelected(circleMember) {
        this.setState({selectedCircleMember: circleMember})
    }

    clearSelectedCircleMember() {
        this.setState({selectedCircleMember: false})
    }

    render() {
        let {token} = this.props;
        let {player, selectedCircleMember, circleMembers, started} = this.state;

        return (
            <div>                
                {player && !started && <ProgressMap home_user={player.home_user} start_func={this.start.bind(this)} token={token}></ProgressMap>}
                {player && started && !selectedCircleMember && <SelectCircleMember circle_members={circleMembers} circle_member_selected_func={this.circleMemberSelected.bind(this)}/>}
                {player && started && selectedCircleMember && <HomeSessionsPage sessions={player.home_sessions} selected_circle_member={selectedCircleMember} token={token} clear_circle_member={this.clearSelectedCircleMember.bind(this)} player={player}/>}
            </div>
        )
    }
}



const withState = connect(state => {
    const {player, player_game_session, player_game_session_activity, result, skill, user} = state;
    

    return {
        players: player.players,
        owned_players: player.owned_players,
        retrieved_assigned_players: player.retrieved_assigned_players,
        retrieved_players: player.retrieved_players,
        assigned_players: player.assigned_players,
        skills: skill.skills,
        results: result.results,
        token: user.token,
        currentUser: user,
        currentUserId: user.currentUserId,
        currentUserFirstName: user.currentUserFirstName,
        playerGameSessions: player_game_session.player_game_sessions,
        playerGameSessionActivities: player_game_session_activity.player_game_session_activities
    };
});

export default withRouter(withState(HomePlayerDashboard));



// WEBPACK FOOTER //
// ./src/components/containers/home-player-dashboard/home-player-dashboard.js